import { StringIfPlural } from 'react-i18next';
import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { ApiResponse } from '../liquidacion_asincrona/LiquidacionAsincronaV2System';

export interface ReportHoursSettlementExistePeriodoPayload {
  sexpasinc_periodo: string;
  sexpasinc_agrcorliq_tipo: string;
}

export type SolicitudExportacionReporteAsincronaEstado =
  | 'REGISTRADO'
  | 'PENDIENTE'
  | 'PROCESANDO'
  | 'PREGENERADO'
  | 'ACEPTADO'
  | 'ELIMINADO';

export interface SolicitudExportacionReporteAsincrona {
  sexpasinc_id?: number;
  sexpasinc_periodo: string | null;
  sexpasinc_agrcorliq_tipo: String;
  sexpasinc_estado?: SolicitudExportacionReporteAsincronaEstado;
  sexpasinc_data?: Record<string, unknown> | null;
  sexpasinc_activo?: number;
  sexpasinc_eliminado?: number;
  sexpasinc_solicitud_colid: number;
  sexpasinc_fecha_creacion?: string;
  sexpasinc_fecha_actualizacion?: string | null;
  sexpasinc_fecha_ejecucion?: string | null;
  sexpasinc_aceptado_colid: number | null;
  sexpasinc_eliminado_colid: number | null;
}

export interface SolicitudExportacionReporteAsincronaList {
  sexpasinc_id: number;
  sexpasinc_periodo: string | null;
  sexpasinc_fecha_ejecucion: string | null;
  colaborador: string;
  sexpasinc_agrcorliq_tipo: string;
  sexpasinc_estado: string;
  sexpasinc_activo: number;
}

/* =========================
   ENUMS
========================= */

export enum ReportHoursSettlementEstado {
  REGISTRADO = 'REGISTRADO',
  PENDIENTE = 'PENDIENTE',
  PROCESANDO = 'PROCESANDO',
  ACEPTADO = 'ACEPTADO',
  ELIMINADO = 'ELIMINADO',
  PREGENERADO = 'PREGENERADO',
}

interface UpdateCompaniesInBillableDistributionPayload {
  period: string;
  companies: any[];
}

export interface SelectOption {
  value: string;
  label: string;
}

export interface BillableDistributionTemplateItem {
  id: string;
  empresa: SelectOption;
  area: SelectOption;
  empresaDestino: SelectOption;
}

export class ReportHoursSettlementSystem {
  private readonly base = '/solicitudes_exportacion_reporte_asincrona';

  constructor(private requestHandler: XhrRequestHandler) {}

  async existsByPeriodo(payload: ReportHoursSettlementExistePeriodoPayload) {
    return this.requestHandler.get<any>(`${this.base}/exists-periodo/${payload.sexpasinc_periodo}/${payload.sexpasinc_agrcorliq_tipo}`);
  }

  async create(payload: SolicitudExportacionReporteAsincrona) {
    return this.requestHandler.post<SolicitudExportacionReporteAsincrona>(`${this.base}`, payload);
  }

  async detail(id: string) {
    return this.requestHandler.get<SolicitudExportacionReporteAsincronaList>(`${this.base}/detail/${id}`);
  }

   getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }

  async accept(id: string) {
    return this.requestHandler.get<any>(`${this.base}/accept/${id}`);
  }

  async eliminate(id: string) {
    return this.requestHandler.get<any>(`${this.base}/delete/${id}`);
  }

  async downloadInformeHoras(id: string): Promise<{ blob: Blob; filename: string }> {
    return this.requestHandler.getBlobWithFilename(`${this.base}/download-informe-horas/${id}`, undefined, 'informe-horas');
  }

  async getInformeHorasParquetData(id: string) {
    return this.requestHandler.get<any>(`${this.base}/informe-horas-data/${id}`) ?? [];
  }

  async updateCompaniesInBillableDistribution(data:UpdateCompaniesInBillableDistributionPayload) {
    return this.requestHandler.post<any>(`${this.base}/update-companies-in-billable-distribution`, data);
  }

  async getCompaniesInBillableDistribution() {
    return this.requestHandler.get<BillableDistributionTemplateItem[]>(`${this.base}/billable-distribution-template`);
  }
}
